export const EndScreen = () => {
  return (
    <main className="h-screen w-full flex justify-center items-center bg-green-700">
      <h1 className="text-xl font-bold text-white text-center">
        You successfully finished your tests. You can now close this tab.
      </h1>
    </main>
  );
};
